var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80001 4V7.64044L11.6529 5.19507C11.8526 5.02386 12.1473 5.02386 12.347 5.19507L19.8137 11.5951C20.0373 11.7867 20.0632 12.1235 19.8715 12.3471C19.6799 12.5707 19.3432 12.5966 19.1196 12.4049L18.4 11.7881V18.9333C18.4 19.5225 17.9225 20 17.3333 20H6.66659C6.07748 20 5.59994 19.5225 5.59994 18.9333V11.7881L4.88033 12.4049C4.6567 12.5966 4.32003 12.5707 4.12838 12.3471C3.93673 12.1235 3.96261 11.7867 4.18624 11.5951L6.66659 9.46899V4H8.80001ZM17.3333 10.8738L12 6.30243L6.66659 10.8738V18.9333H9.99996V14C9.99996 13.4477 10.4477 13 11 13H13C13.5522 13 14 13.4477 14 14V18.9333H17.3333V10.8738Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.babfdb0f00b1add40d9c99d0aaa8f7a9.svg";
export { ForwardRef as ReactComponent };